import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import LoadingSpinner from "./LoadingSpinner";
import { ROUTES } from "../../utils/constants";

/**
 * ProtectedRoute Component
 *
 * Provides route protection for authenticated users only.
 * Redirects unauthenticated users to login page.
 *
 * Requirements: 3.4, 3.5
 */
const ProtectedRoute = ({ children, requireAuth = true }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="protected-route-loading">
        <LoadingSpinner />
        <p>Checking authentication...</p>
      </div>
    );
  }

  // If authentication is required but user is not authenticated
  if (requireAuth && !isAuthenticated) {
    // Redirect to login with the current location as state
    // so we can redirect back after successful login
    return (
      <Navigate to={ROUTES.ADMIN_LOGIN} state={{ from: location }} replace />
    );
  }

  // If user is authenticated but trying to access login page
  if (
    !requireAuth &&
    isAuthenticated &&
    location.pathname === ROUTES.ADMIN_LOGIN
  ) {
    // Redirect to dashboard if already authenticated
    return <Navigate to={ROUTES.ADMIN_DASHBOARD} replace />;
  }

  // Render the protected component
  return children;
};

export default ProtectedRoute;
